import { idtype } from "querypieces";
import resourceBuilder from "components/resource-builder/query";

export default `
...on pageBuilder_getInformedQuestions_BlockType {
	${idtype}
	getInformedQuestions {
		...on question_Entry {
			${idtype}
			title
			colors
			children {
				...on getInformedQuestions_Entry {
					${idtype}
					title
					resourceBuilder {
						${resourceBuilder}
					}
				}
			}
		}
	}
}
`;
